import React from 'react';
import { ScrollView } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { ErrorScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import CurrentDeviceCard from '../../Components/CurrentDeviceCard';
import CurrentDeviceCardLoading from '../../Components/CurrentDeviceCardLoading';

import styles from './Devices.Styles';

const Devices = ({
  withTray,
  CurrentDeviceData,
  mobileName,
  onMobileNameChange,
  containerStyle,
  isLoading,
  theme,
  images,
  isError,
  errorText,
  errorIconName,
  tryAgainIconName,
  onTryAgainPress,
}) => {
  const {
    deviceType,
    deviceName,
    image,

    deviceExtraInfo,
    deviceExtraInfoTitleStyle,
    deviceExtraInfoSubTitleStyle,

    withShowMore,
    showMoreContent,
    showMoreContentDataLabelStyle,
    showMoreContentDataValueStyle,

    isUpgradeAvailable,
    onPressUpgradenow,
  } = CurrentDeviceData;
  return (
    <ScrollView
      scrollEnabled={!isLoading}
      style={[styles.container, containerStyle]}
      contentContainerStyle={styles.scrollViewContainerStyle(withTray)}
    >
      <VFText i18nKey="my_device_screen_title" style={styles.headerTitle(theme)} />
      {isError ? null : (
        <VFText i18nKey="my_device_screen_subtitle" style={styles.headerSubTitle(theme)} />
      )}
      {isLoading ? (
        <CurrentDeviceCardLoading />
      ) : isError ? (
        <ErrorScreen
          text={errorText}
          images={images}
          iconName={errorIconName}
          iconButtonName={tryAgainIconName}
          onPress={onTryAgainPress}
          backgroundStyle={styles.errorContainer}
          iconStyle={styles.errorIcon}
        />
      ) : (
        <CurrentDeviceCard
          mobileName={mobileName}
          onMobileNameChange={onMobileNameChange}
          deviceType={deviceType}
          deviceName={deviceName}
          image={image}
          isUpgradeAvailable={isUpgradeAvailable}
          onPressUpgradenow={onPressUpgradenow}
          deviceExtraInfo={deviceExtraInfo}
          deviceExtraInfoTitleStyle={deviceExtraInfoTitleStyle}
          deviceExtraInfoSubTitleStyle={deviceExtraInfoSubTitleStyle}
          withShowMore={withShowMore}
          showMoreContent={showMoreContent}
          showMoreContentDataLabelStyle={showMoreContentDataLabelStyle}
          showMoreContentDataValueStyle={showMoreContentDataValueStyle}
        />
      )}
    </ScrollView>
  );
};

Devices.defaultProps = {};
Devices.propTypes = {
  withTray: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  onPressUpgradenow: PropTypes.func,
  onMobileNameChange: PropTypes.func,
  mobileName: PropTypes.string,
  CurrentDeviceData: PropTypes.shape({
    deviceType: PropTypes.string,
    deviceName: PropTypes.string,
    isUpgradeAvailable: PropTypes.bool,
    image: PropTypes.object,
    onPressUpgradenow: PropTypes.func,
    deviceExtraInfo: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      }),
    ),
    deviceExtraInfoTitleStyle: TextPropTypes.style,
    deviceExtraInfoSubTitleStyle: TextPropTypes.style,
    withShowMore: PropTypes.bool,
    showMoreContent: PropTypes.shape({
      description: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        }),
      ),
    }),
    showMoreContentDescriptionStyle: TextPropTypes.style,
    showMoreContentDataLabelStyle: TextPropTypes.style,
    showMoreContentDataValueStyle: TextPropTypes.style,
  }),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isLoading: PropTypes.bool,
  images: PropTypes.object,
  isError: PropTypes.bool,
  errorText: PropTypes.string,
  errorIconName: PropTypes.string,
  tryAgainIconName: PropTypes.string,
  onTryAgainPress: PropTypes.func,
};
export { Devices };
export default withTheme(Devices);
